export default function SpotifyEmbedded(props: {
  id: string;
  variant: string;
  title: string;
}) {
  const { id, title, variant } = props;
  return (
    <iframe
      title={title}
      className="rounded-lg"
      src={`https://open.spotify.com/embed/${variant}/${id}?utm_source=generator`}
      width="100%"
      height="80"
      frameBorder="0"
      allowFullScreen={false}
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    ></iframe>
  );
}
